import React, { useState } from 'react';
import { gallery } from '../data/mock';

const Gallery = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedImage, setSelectedImage] = useState(null);

  const categories = [
    { id: 'all', label: 'All' },
    { id: 'Tests', label: 'Tests & Assessment' },
    { id: 'Teaching', label: 'Teaching' },
    { id: 'Activities', label: 'Activities' },
    { id: 'Classroom', label: 'Classrooms' }
  ];

  const filteredGallery =
    selectedCategory === 'all'
      ? gallery
      : gallery.filter((item) => item.category === selectedCategory);

  return (
    <div className="min-h-screen pt-24 pb-12">
      <div className="container mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="heading-hero mb-4">Our Institute</h1>
          <p className="body-large text-[var(--text-secondary)] max-w-2xl mx-auto mb-8">
            Take a tour of our modern facilities designed for optimal learning
          </p>

          {/* Category Filters */}
          <div className="flex flex-wrap justify-center gap-3">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`px-6 py-2 rounded-full font-mono text-sm uppercase tracking-wider transition-all ${
                  selectedCategory === category.id
                    ? 'bg-[var(--text-primary)] text-white'
                    : 'bg-white border border-[var(--border-primary)] text-[var(--text-primary)] hover:border-[var(--text-primary)]'
                }`}
              >
                {category.label}
              </button>
            ))}
          </div>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {filteredGallery.map((item) => (
            <div
              key={item.id}
              className="relative group cursor-pointer overflow-hidden rounded-xl shadow-sm hover-lift"
              onClick={() => setSelectedImage(item)}
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={item.images?.[0]}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <h3 className="text-white font-semibold mb-1">{item.title}</h3>
                  <p className="text-white/80 text-sm font-mono uppercase tracking-wider">
                    {item.category}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Facilities Info */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="bg-[var(--accent-purple-200)] rounded-xl p-6 text-center">
            <h3 className="heading-3 mb-2">Weekly & Monthly Tests</h3>
            <p className="body-small text-[var(--text-secondary)]">
              Regular assessment with test series developed by CBSE officials
            </p>
          </div>

          <div className="bg-[var(--accent-blue-200)] rounded-xl p-6 text-center">
            <h3 className="heading-3 mb-2">IIT-ian Faculty</h3>
            <p className="body-small text-[var(--text-secondary)]">
              Courses designed and taught by IIT graduate with proven expertise
            </p>
          </div>

          <div className="bg-[var(--accent-orange-200)] rounded-xl p-6 text-center">
            <h3 className="heading-3 mb-2">Well-Equipped Classrooms</h3>
            <p className="body-small text-[var(--text-secondary)]">
              Modern learning environment with all necessary facilities
            </p>
          </div>

          <div className="bg-[var(--accent-green-200)] rounded-xl p-6 text-center">
            <h3 className="heading-3 mb-2">Trips & Outings</h3>
            <p className="body-small text-[var(--text-secondary)]">
              Educational trips and refreshment activities for holistic development
            </p>
          </div>
        </div>
      </div>

      {/* Image Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/90 z-[9999] flex items-center justify-center p-4 overflow-y-auto"
          onClick={() => setSelectedImage(null)}
        >
          <div
            className="relative max-w-5xl w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setSelectedImage(null)}
              className="absolute -top-12 right-0 text-white text-sm font-mono uppercase tracking-wider hover:opacity-70"
            >
              Close ✕
            </button>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {selectedImage.images?.map((img, index) => (
                <img
                  key={index}
                  src={img}
                  alt={`${selectedImage.title} ${index + 1}`}
                  className="w-full h-auto max-h-[85vh] object-contain rounded-xl"
                />
              ))}
            </div>

            <div className="mt-4 text-center">
              <h3 className="text-white text-xl font-semibold mb-1">
                {selectedImage.title}
              </h3>
              <p className="text-white/70 text-sm font-mono uppercase tracking-wider">
                {selectedImage.category}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;
